import React from "react";

import UserPageTemplate from "components/user-page-template/user-page-template";

export default function Announcers() {
  return <UserPageTemplate userRoute="/announcers" nameOfUser="Announcer" />;
}
